var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-content-mobileFull bg-grey3 radius-18" },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-top bg-grey3 radius-18 radius-bottom-0 p-20 top-0 pos-sticky zindex-2",
        },
        [
          _c(
            "button",
            {
              staticClass:
                "close rounded-btn display-3 p-0 bg-grey3 pull-right",
              attrs: { type: "button", "aria-label": "Close" },
              on: {
                click: function ($event) {
                  return _vm.dismiss()
                },
              },
            },
            [
              _c(
                "span",
                {
                  staticClass: "font-lato text-light",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("×")]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._m(0),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column modal-main bg-grey3 radius-18 radius-top-0 pos-relative zindex-0",
          staticStyle: { "min-height": "400px" },
        },
        [
          _c("salearea-select", { attrs: { order: _vm.order } }),
          _vm._v(" "),
          _vm.order.SaleAreaId != _vm.DELIVERY
            ? _c("ul", { staticClass: "list-group" }, [
                _c(
                  "li",
                  {
                    staticClass:
                      "cursor-pointer list-group-item flex-start-center",
                    on: {
                      click: function ($event) {
                        return _vm.$emit("go", 1, _vm.CHECKOUT.CHOOSE_SHOP)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-2x fa-map-marker p-10" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "flex-column" }, [
                      _c("div", [_vm._v(_vm._s(_vm.order.shop.DefaultName))]),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.order.shop.Address1) +
                            " " +
                            _vm._s(_vm.order.shop.Address2) +
                            ", " +
                            _vm._s(_vm.order.shop.Zip) +
                            " " +
                            _vm._s(_vm.order.shop.City)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("i", {
                      staticClass: "fa fa-chevron-right p-10 ml-auto",
                    }),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("address-select", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.order.SaleAreaId == _vm.DELIVERY,
                expression: "order.SaleAreaId == DELIVERY",
              },
            ],
            attrs: { msg: _vm.$refs.msg, order: _vm.order },
            on: { "set-address-zone": _vm.setAddressZone, go: _vm.mygo },
          }),
          _vm._v(" "),
          _c("ul", { staticClass: "list-group" }, [
            _c(
              "li",
              {
                staticClass: "cursor-pointer list-group-item flex-start-center",
                on: {
                  click: function ($event) {
                    return _vm.$emit("go", 1, _vm.CHECKOUT.DELIVERY_DATE)
                  },
                },
              },
              [
                _c("i", { staticClass: "fa fa-2x fa-clock-o p-10" }),
                _vm._v(" "),
                _vm.dateTime
                  ? _c(
                      "div",
                      {
                        class: {
                          "text-danger":
                            _vm.dateTime.time && _vm.dateTime.time.is_full,
                        },
                      },
                      [
                        _vm.dateTime.date.is_closed
                          ? _c("span", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.dateTime.date.title) +
                                  " (fermé)\n\t\t\t\t\t"
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.dateTime.date.is_closed
                          ? _c("span", [
                              _vm._v(
                                "\n\t\t\t\t\t\t" +
                                  _vm._s(_vm.dateTime.time.title) +
                                  "\n\t\t\t\t\t\t"
                              ),
                              _vm.dateTime.time.is_full
                                ? _c("span", [_vm._v("(complet)")])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("i", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.loadingDate,
                              expression: "loadingDate",
                            },
                          ],
                          staticClass: "loading",
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.order.PickupTimeDate && !_vm.dateTime
                  ? _c("div", [
                      _vm._v("\n\t\t\t\t\tValidation de l'horaire\n\t\t\t\t\t"),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loadingDate,
                            expression: "loadingDate",
                          },
                        ],
                        staticClass: "loading",
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.order.PickupTimeDate
                  ? _c("div", [
                      _vm._v("\n\t\t\t\t\tChoisissez un horaire\n\t\t\t\t\t"),
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.loadingDate,
                            expression: "loadingDate",
                          },
                        ],
                        staticClass: "loading",
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("i", { staticClass: "fa fa-chevron-right p-10 ml-auto" }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("checkout-client-login"),
              _vm._v(" "),
              false
                ? _c(
                    "div",
                    { staticClass: "flex-between-center", class: _vm.msgClass },
                    [_c("span", [_vm._v(_vm._s(_vm.msg))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("Msg", { ref: "msg", attrs: { processing: _vm.processing } }),
              _vm._v(" "),
              false
                ? _c(
                    "p",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errorMsg,
                          expression: "errorMsg",
                        },
                      ],
                      staticClass: "text-danger pt-10",
                    },
                    [_vm._v(_vm._s(_vm.errorMsg))]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c("div", { staticClass: "flex-center-center" }, [
          _c(
            "button",
            {
              staticClass:
                "btnFlat-color2 my-10 mx-10 flex-1 fsize-18 shadow-1",
              on: {
                click: function ($event) {
                  return _vm.validateChoices(true)
                },
              },
            },
            [_vm._v("Confirmer")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-center" }, [
      _c(
        "div",
        {
          staticClass:
            "modal-top--title fsize-18 color-grey1 text-bold xtext-uppercase radius-18 radius-bottom-0",
        },
        [_vm._v("\n\t\t\t\tMode de commande\n\t\t\t")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }